<template>
  <v-flex xs12 class="mb-4">
    <div class style="position: relative;">
      <div class="flex-container-space-between vertical-center-container">
        <page-title :routeProps="routeProps"></page-title>
        <div class="text-xs-right">
          <v-btn flat color="grey" @click="toggleView()">
            <v-icon left v-if="listView">list</v-icon>
            <v-icon left v-else>view_module</v-icon>View
          </v-btn>
        </div>
      </div>
      <layout-no-padding>
        <v-flex xs12 sm6 md3>
          <v-select
            label="Sort by..."
            :items="sortFactors"
            v-model="sortBy"
            prepend-icon="sort"
            :disabled="listView"
            dense
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field label="Filter by..." v-model="filterBy" prepend-icon="filter_list"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-select label="Type" :items="['Active', 'Request']" v-model="selectedRecordType"></v-select>
        </v-flex>
      </layout-no-padding>

      <v-dialog v-model="addTipDialog" max-width="500px" @keydown.esc="addTipDialog = false">
        <v-btn fab dark :color="routeProps.color" class="overlap-fab-tip" slot="activator">
          <v-icon dark>{{ isRequest ? 'post_add' : 'add' }}</v-icon>
        </v-btn>
        <!-- ADD DRIVER COMPONENT-->
        <add-tip @close="addTipDialog = false" :isRequest="isRequest"></add-tip>
      </v-dialog>
      <card-divider-split></card-divider-split>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </v-flex>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import TipValidation from '@/services/validation/tipValidation'
import AddTip from '@/components/tips/addTip'
import RouteProps from '@/services/mixins/routeProps'

//GET RECORDS
import getSpoils from '@/services/mixins/getMasterFiles/getSpoils'
import getProjects from '@/services/mixins/getMasterFiles/getProjects'
import getTips from '@/services/mixins/getMasterFiles/getTips'
export default {
  mixins: [TipValidation, RouteProps, getSpoils, getTips, getProjects],
  data() {
    return {
      includeInactive: true,
      addTipDialog: false,
      sortFactors: [
        {
          value: 'id',
          text: 'ID',
        },
        {
          value: 'name',
          text: 'Name',
        },
        {
          value: 'updatedAt',
          text: 'Updated At',
        },
      ],
    }
  },
  methods: {
    toggleView() {
      this.listView = !this.listView
    },
    sortTips(path1, path2) {
      return this.tips.sort((a, b) => {
        if (a[path] < b[path]) {
          return -1
        } else {
          return 1
        }
      })
    },
  },
  computed: {
    isRequest() {
      return this.$store.state.user.userAuthClass.name !== 'Administrator'
    },
    sortBy: Store.getSet({ store: 'tips', prop: 'sortBy' }),
    filterBy: Store.getSet({ store: 'tips', prop: 'filterBy' }),
    listView: Store.getSet({ store: 'tips', prop: 'listView' }),
    selectedRecordType: Store.getSet({
      store: 'tips',
      prop: 'selectedRecordType',
    }),
  },
  components: {
    AddTip,
  },
}
</script>

<style scoped>
.overlap-fab-tip {
  right: 40px;
  bottom: -17px;
  position: absolute !important;
}
</style>
